<template>
  <div>
    <div class="container">
      <div class="row text-light pb-3 pt-2 mt-1">
        <div class="col-12">
          <form
            class="search-form search-form-theme2 w-100"
            @submit.prevent
          >
            <img
              src="@/assets/images/skeleton/search.png"
              class="fas fa-search search-icon"
              alt="search"
            >
            <input
              v-model="filter.keyword"
              type="text"
              placeholder="Search in Experiments"
              name="Search"
              class="search-input"
            >
          </form>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 px-2">
          <div class="container">
            <center v-if="load">
              <b-spinner
                variant="primary"
                label="Spinning"
              />
            </center>
            <div
              v-else
              class="row"
            >
              <div
                v-for="(item, index) in items.data"
                :key="item.id || index"
                class="col-lg-3 col-md-6 d-flex justify-content-center"
              >
                <div
                  v-if="item"
                  class="card bg-transparent cursor-pointer exp-card"
                  :class="{ featured: item.is_featured }"
                  @click="navigateEXP(item.id)"
                >
                  <div>
                    <div class="image-wrapper">
                      <div class="img-exp">
                        <img
                          :src="item.cachedImage || item.image"
                          alt="image"
                          style="border-radius: 5px"
                        >

                        <!-- BADGE CONTAINER -->
                        <div class="badge-container">
                          <span
                            v-if="item.is_pinned"
                            class="pin-badge"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="14"
                              height="14"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="feather feather-pin"
                            >
                              <line
                                x1="12"
                                y1="17"
                                x2="12"
                                y2="22"
                              />
                              <path d="M5 17h14v-1.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 11.24V6a3 3 0 0 0-6 0v5.24a2 2 0 0 1-1.11 1.31l-1.78.9A2 2 0 0 0 5 15.24Z" />
                            </svg>
                          </span>

                          <span
                            v-if="item.is_featured "
                            class="feature-badge"
                            :class="{ active: item.is_featured, clickable: isAdmin }"
                          >
                            <!-- @click.stop="toggleFeature(item)" -->
                            <feather-icon
                              icon="StarIcon"
                              size="12"
                              :class="{ 'star-active': item.is_featured, 'star-inactive': !item.is_featured }"
                            />
                            Featured
                          </span>

                          <span
                            v-if="item.is_new"
                            class="new-badge"
                          >
                            <!-- <feather-icon icon="ZapIcon" size="12" /> -->

                            New
                          </span>
                        </div>

                        <img
                          v-b-tooltip.hover.top="'Run only via VR'"
                          src="@/assets/images/skeleton/play.png"
                          class="play-button"
                          alt="play-button"
                        >

                      </div>
                    </div>
                    <div class="py-1 pl-0 exp-info-wrapper">
                      <h3
                        v-if="item.name"
                        class="mb-0 exp-title"
                      >
                        {{ item.name }}
                      </h3>
                      <p
                        v-if="item.category_name"
                        class="opacity-75 exp-desc"
                      >
                        {{ item.category_name }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { mapGetters } from 'vuex'
import vSelect from 'vue-select'
import DragTable from '@/views/components/tables/DragTable.vue'

import {
  BTable,
  BButton,
  BFormCheckbox,
  BCard,
  BRow,
  BCol,
  BBadge,
  BCardText,
  BAvatar,
  VBTooltip,
  BLink,
  BSpinner,
  BPagination,
} from 'bootstrap-vue'

export default {
  name: 'Home',
  components: {
    BTable,
    BButton,
    BFormCheckbox,
    BCard,
    BRow,
    BCol,
    BBadge,
    BAvatar,
    BCardText,
    BLink,
    BSpinner,
    BPagination,
    ToastificationContent,
    DragTable,
    vSelect,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  watch: {
    'filter.keyword': function (newVal) {
      this.$store.dispatch('experiments/list', this.filter)
    },
    $route(to, from) {
      if (to.params.id !== from.params.id) {
        this.init()
      }
    },
  },
  computed: {
    ...mapGetters({
      items: 'experiments/items',
      load: 'experiments/load',
      courses: 'experiments/lookups',
      modules: 'experiments/lookups',
    }),
    categoryID() {
      return this.$route.params.id ? this.$route.params.id : null
    },
    isAdmin() {
      return this.authUser() && this.authUser().roles ? this.authUser().roles.includes('Admin') : false
    },
  },
  data() {
    return {
      filter: {
        category_id: this.categoryID,
        keyword: null,
      },
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.filter.category_id = this.categoryID
      this.$store
        .dispatch('experiments/list', this.filter)
        .then(response => {})
    },
    toggleFeature(item) {
      if (!this.isAdmin) return

      this.$store.dispatch('experiments/toggleFeatured', item.id)
        .then(res => {
          // this.$swal({
          //   icon: "success",
          //   title: res.message,
          //   confirmButtonColor: "#7367f0",
          // });
          this.init()
        })
    },
    navigateEXP(id) {
      this.$router.push({ name: 'experiment_details', params: { id } })
    },
    openExperiment(id) {
      if (id) {
        setTimeout(() => {
          window.vuplex.postMessage(id)
        }, 3)
      } else {
        console.log('No ID provided in the URL.')
      }
    },
    searchExperiments() {
      console.log('Search triggered')
    },
  },
}
</script>

<style lang="scss" scoped>
.card,
.card * {
  box-shadow: unset;
  color: #fff;
}
.image-wrapper {
  border-radius: 10px;
  overflow: hidden;
  height: 246px;
  width: 246px;
}
.search-form {
  position: relative;
  z-index: 1000;
  width: 100%;
  background-color: transparent;
  border: 1px solid #ffffff75;
  border-left: none;
  border-right: none;
  border-radius: 15px;
  box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.4);
  padding: 10px 20px 10px 45px;
  transition: box-shadow 0.3s ease;
}

.search-form-theme2 {
  position: relative;
  z-index: 1000;
  width: 100%;
  border-left: none;
  border-right: none;
  padding: 10px 20px 10px 45px;
  transition: box-shadow 0.3s ease;
  background-color: #00000040;
  border: 1px solid #ffffff75;
  border-radius: 15px;
  box-shadow: inset 0 2px 5px rgb(0 0 0 / 65%);
  border-top: unset;
}

.search-form:focus-within {
  box-shadow: 0 0 5px rgba(255, 255, 255, 0.2);
}

.search-form input[type="text"],
.search-form input[type="search"] {
  width: 100%;
  background: transparent;
  border: none;
  color: #fff;
  font-size: 16px;
  outline: none;
}

.search-form input::placeholder {
  color: #ffffffa8;
}

.search-form .search-icon {
  position: absolute;
  top: 50%;
  left: 15px;
  transform: translateY(-50%);
  color: #bbb;
  font-size: 16px;
  cursor: pointer;
}
.img-exp {
  position: relative;
  width: 100%;
}

.img-exp > img:not(.play-button) {
  display: block;
  width: 100%;
  height: 18rem;
  object-fit: cover;
  border-radius: 5px;
}
.play-button {
  position: absolute;
  cursor: not-allowed;
  bottom: 5%;
  right: 3%;
}
</style>

<style scoped>
/* Remove box-shadow from the card */
.exp-card.featured {
  border: none;  /* remove border from card too */
  transform: scale(1.02);
}

/* Apply the glow shadow to the image wrapper instead */
.exp-card.featured .image-wrapper {
  box-shadow: 0 0 15px #0fdbdeb1;
  /* border: 2px solid #f7c948; */
  border-radius: 10px;
}

.feature-badge{
  padding:4px 8px;
  font-size:12px;
  border-radius:20px;
  background:#444;
  color:#fff;
  transition:.3s;
  padding-bottom: 5px;
}

.feature-badge.active{
  background:#000A1E;
  color:#fff;
  font-weight:bold;
}

.feature-badge.clickable{
  cursor:pointer;
}

.star-inactive {
  color: #888;
  stroke: #888;
  margin-right: 3px;
}

.star-active {
  color: #f7c948;
  stroke: #f7c948;
  fill: #f7c948;
  margin-right: 3px;
}

.new-badge {
  padding: 4px 10px;
  font-size: 12px;
  border-radius: 20px;
  background:#fff;
  color:#28c76fe5 !important;
  font-weight: 600;
  transition:.3s;
  padding-bottom: 4px;
}

.badge-container {
  position: absolute;
  top: 10px;
  left: 10px;
  display: flex;
  gap: 2px;
  align-items: center;
  background: transparent;
}

.pin-badge {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #000a1ecc;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pin-badge .feather {
  color: #fff;
  stroke: #fff;
}

.ZapIcon
 {
  stroke:#28c76fe5 !important;
 }
</style>
